import React from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

//Paginas
import DashboardPage from '../pages/dashboard';
import BannersPage from '../pages/banners';
import NovoBannerPage from '../pages/banners/novo';
import EditarBannerPage from '../pages/banners/editar';
import EventosPage from '../pages/eventos';
import NovoEventoPage from '../pages/eventos/novo';
import EditarEventoPage from '../pages/eventos/editar';
import LojasPage from '../pages/lojas';
import NovaLojaPage from '../pages/lojas/nova';
import EditarLojaPage from '../pages/lojas/editar';
import ServicosPage from '../pages/servicos';
import NovoServicoPage from '../pages/servicos/novo';
import EditarServicoPage from '../pages/servicos/editar';
import UsuariosPage from '../pages/usuarios';
import NovoUsuarioPainelPage from '../pages/usuarios/novo';
import EditarUsuarioPainelPage from '../pages/usuarios/editar';
import ConfiguracoesPage from '../pages/configuracoes';
import SegmentosPage from '../pages/segmentos';
import ContatosPage from '../pages/contatos';
import PromocoesPage from '../pages/promocoes';
import NovaPromocaoPage from '../pages/promocoes/nova';
import EditarPromocaoPage from '../pages/promocoes/editar';

export const MenusAdmin = [
	{
		title:'Dashboard',
		icon:'dashboard',
		url:'/painel/dashboard'
	},
	{
		title:'Banners',
		icon:'image',
		url:'/painel/banners'
	},
	{
		title:'Eventos',
		icon:'event',
		url:'/painel/eventos'
	},
	{
		title:'Promoções',
		icon:'card_giftcard',
		url:'/painel/promocoes'
	},
	{
		title:'Segmentos',
		icon:'list',
		url:'/painel/segmentos'
	},
	{
		title:'Lojas',
		icon:'shopping_basket',
		url:'/painel/lojas'
	},
	{
		title:'Serviços',
		icon:'home',
		url:'/painel/servicos'
	},
	{
		title:'Configurações',
		icon:'settings',
		url:'/painel/configuracoes'
	},
	{
		title:'Usuários',
		icon:'group',
		url:'/painel/usuarios'
	},
	{
		title:'Contatos',
		icon:'contacts',
		url:'/painel/contatos'
	},
]

class AppAdmin extends React.Component {
    render() {
		const { match } = this.props;
        return (
				<Switch>
					<Route exact path={`${match.path}/dashboard`} component={DashboardPage} />
					<Route exact path={`${match.path}/banners`} component={BannersPage} />
					<Route exact path={`${match.path}/banners/novo`} component={NovoBannerPage} />
					<Route exact path={`${match.path}/banners/:id`} component={EditarBannerPage} />
					<Route exact path={`${match.path}/eventos`} component={EventosPage} />
					<Route exact path={`${match.path}/eventos/novo`} component={NovoEventoPage} />
					<Route exact path={`${match.path}/eventos/:id`} component={EditarEventoPage} />
					<Route exact path={`${match.path}/lojas`} component={LojasPage} />
					<Route exact path={`${match.path}/lojas/nova`} component={NovaLojaPage} />
					<Route exact path={`${match.path}/lojas/:id`} component={EditarLojaPage} />
					<Route exact path={`${match.path}/servicos`} component={ServicosPage} />
					<Route exact path={`${match.path}/servicos/novo`} component={NovoServicoPage} />
					<Route exact path={`${match.path}/servicos/:id`} component={EditarServicoPage} />
					<Route exact path={`${match.path}/promocoes`} component={PromocoesPage} />
					<Route exact path={`${match.path}/promocoes/nova`} component={NovaPromocaoPage} />
					<Route exact path={`${match.path}/promocoes/:id`} component={EditarPromocaoPage} />
					<Route exact path={`${match.path}/configuracoes`} component={ConfiguracoesPage} />
					<Route exact path={`${match.path}/usuarios`} component={UsuariosPage} />
					<Route exact path={`${match.path}/usuarios/novo`} component={NovoUsuarioPainelPage} />
					<Route exact path={`${match.path}/usuarios/:id`} component={EditarUsuarioPainelPage} />
					<Route exact path={`${match.path}/segmentos`} component={SegmentosPage} />
					<Route exact path={`${match.path}/contatos`} component={ContatosPage} />
					<Redirect from="*" to={`${match.path}/dashboard`} />
				</Switch>
        );
    }
}

export default withRouter(AppAdmin);



// WEBPACK FOOTER //
// ./src/painel/RouterNivel/Administrador.js